export enum NavigationSlugs {
    Main = 'main',
    MainLoggedIn = 'main.logged-in',
    MainBcm = 'main.bcm',
    MainDmyv = 'main.dmyv',
    MainAdmin = 'main.admin',
}
